import React, { useMemo } from 'react';

import ReadersType from './ComponentsTpes/ReadersTypes';

const RFID = ({ selectedPorts, defaultPort,componentSourceOptions,
    setSelectedPorts, savedData, setSavedData, selectedType, ACUModel }) => {
    const selectOptions = (key, value) => {
        setSavedData(prevData => {
            return {
                ...prevData,
                [`RFID${defaultPort}`]: {
                    ...prevData[`RFID${defaultPort}`],
                    [key]: value
                }
            }
        })
    }

    const data = useMemo(() => {
        return savedData[`RFID${selectedType.defaultName}`]
    }, [savedData, selectedType.defaultName])

  if (!data) {
      return <>
            <h4> Data Not Found ...</h4>
        </>
    }
  return (<ReadersType
        ACUModel={ ACUModel}
        source={componentSourceOptions.readersData}
        key={`RFID${defaultPort}`}
        component_source={savedData[`RFID${defaultPort}`]?.component_source?.value }
        setSelectedPorts={setSelectedPorts}
        selectedPorts={selectedPorts}
        selectOptions={selectOptions}
        name={data.name}
        port={data.port}
        mode={data.mode}
        readerType={data.readerType}
        wiegandType={ data.wiegandType}
        enable_crc={data.enable_crc}
        reverse_byte_order={data.reverse_byte_order}
        direction={data.direction}
        enable_buzzer={data.enable_buzzer} />)
}

export default RFID;